export enum PinStyleEnum {
  Pin = 1,
  Form = 2,
  GeoPin = 5,
  Detail = 7,
  Scribble = 8,
  Target = 9,
  CustomPin = 10
}
